/* eslint-disable no-unused-vars */

import "../../styles/styles.css";

import React, { useEffect, useState } from "react";
import { Col, Image, Nav, Row, Spinner, Tab } from "react-bootstrap";
import { getDiaEvento, getHoraFmt } from "./../../utils/fechas";

import { useTranslation } from "react-i18next";
import portugale700 from "./../../assets/accesibilidad.png";
import CartaEvento from "./../CartaEvento/CartaEvento";

function Calendario({ eventos_ciclo, ciclo }) {
  const [eventos_julio, setEventosJulio] = useState([]);
  const [eventos_agosto, setEventosAgosto] = useState([]);
  const [eventos_septiembre, setEventosSeptiembre] = useState([]);
  const [mes, setMes] = useState("");
  const [nav, setNav] = useState(false);
  const [t, i18n] = useTranslation("global");
  const [loading, setLoading] = useState(true);
  const [cicloEus, setCicloEus] = useState("");
  /*  */
  /* if (ciclo.description !== "") {
    var arrayDeCadenas = ciclo.description.split("#");
    var parrafoEspañol = arrayDeCadenas[1].split(".-");
    var parrafoEuskera = arrayDeCadenas[0].split(".-");
  } else {
    arrayDeCadenas = [];
    parrafoEspañol = [];
    parrafoEuskera = [];
  } */

  useEffect(() => {
    if (ciclo.name !== "") {
      if (ciclo.name === "Biblioteca Municipal") {
        setCicloEus("Udal Liburutegia");
      }
      if (ciclo.name === "Museo de la Industria Rialia") {
        setCicloEus("Rialia Industria");
      }
      if (ciclo.name === "Espectáculos") {
        setCicloEus("Ikuskizuna");
      }
      if (ciclo.name === "Centro Cultural Santa Clara") {
        setCicloEus("Santa Clara Kulturtegia");
      }
    }
    eventos_julio.length = 0;
    eventos_agosto.length = 0;
    eventos_septiembre.length = 0;

    eventos_ciclo.forEach((element) => {
      if (element.startDate.includes("2023-06")) {
        element.tickets.forEach((element) => {
          element.hora_fmt = getHoraFmt(element.startDate);
        });
        element.dia_fmt = getDiaEvento(element.startDate);
        element.dia_fmt = getDiaEvento(element.startDate);
        let minutes;
        let hora = new Date(element.startDate).getHours();
        if (new Date(element.startDate).getMinutes() < 10) {
          minutes = "0" + new Date(element.startDate).getMinutes();
        } else {
          minutes = new Date(element.startDate).getMinutes();
        }
        element.hora_fmt = hora + ":" + minutes;
        eventos_julio.push(element);
      }
      if (element.startDate.includes("2023-07")) {
        element.tickets.forEach((element) => {
          element.hora_fmt = getHoraFmt(element.startDate);
        });
        element.dia_fmt = getDiaEvento(element.startDate);
        element.dia_fmt = getDiaEvento(element.startDate);
        let minutes;
        let hora = new Date(element.startDate).getHours();
        if (new Date(element.startDate).getMinutes() < 10) {
          minutes = "0" + new Date(element.startDate).getMinutes();
        } else {
          minutes = new Date(element.startDate).getMinutes();
        }
        element.hora_fmt = hora + ":" + minutes;
        eventos_agosto.push(element);
      }

      if (element.startDate.includes("2023-08")) {
        element.tickets.forEach((element) => {
          element.hora_fmt = getHoraFmt(element.startDate);
        });
        element.dia_fmt = getDiaEvento(element.startDate);
        element.dia_fmt = getDiaEvento(element.startDate);
        let minutes;
        let hora = new Date(element.startDate).getHours();
        if (new Date(element.startDate).getMinutes() < 10) {
          minutes = "0" + new Date(element.startDate).getMinutes();
        } else {
          minutes = new Date(element.startDate).getMinutes();
        }
        element.hora_fmt = hora + ":" + minutes;
        eventos_septiembre.push(element);
      }
    });

    if (!nav) {
      if (eventos_julio.length > 0) {
        setMes("junio");
      } else if (eventos_agosto.length > 0) {
        setMes("julio");
      }else if (eventos_septiembre.length > 0) {
        setMes("agosto");
      }
    }

    if (loading) {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  return (
    <div style={{margin: "20px"}}>
      {loading ? (
        <Spinner animation="border" />
      ) : (
        <Tab.Container defaultActiveKey={mes}>

         <Row xs={2} lg={1} style={{ justifyContent: "center" }}>
            <h2
              style={{
                justifyContent: "center",
                display: "flex",
                marginTop: "50px",
                textAlign: "center",
                fontSize: "22px",
              }}
            >
              {t("header.Aviso-importante1")}
            </h2>
          </Row>

          <Row
            xs={2}
            lg={1}
            style={{
              justifyContent: "center",
              marginTop: "20px",
              textAlign: "center",
            }}
          >
            <h4
              style={{
                fontSize: "16px",
              }}
            >
              {t("header.Aviso-importante2")}
            </h4>
          </Row>

          <Row
            xs={2}
            lg={1}
            style={{
              justifyContent: "center",
              marginTop: "20px",
              textAlign: "center",
            }}
          >
            <h4
              style={{
                fontSize: "16px",
              }}
            >
              {t("header.Aviso-importante3")}
            </h4>
          </Row>

          <Row
            xs={2}
            lg={1}
            style={{
              justifyContent: "center",
              marginTop: "20px",
              textAlign: "center",
            }}
          >
            <h4
              style={{
                fontSize: "16px",
              }}
            >
              {t("header.Aviso-importante4")}
            </h4>
          </Row>

          <Row
            xs={2}
            lg={1}
            style={{
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <p
              style={{
                fontSize: "16px",
              }}
            >
              {t("header.Aviso-importante5")}
            </p>
          </Row>
          
          {ciclo.name === 'Espectáculos' ? <> <Row xs={2} lg={1} style={{ justifyContent: "center", display: "flex" }}>
          
          <Row style={{justifyContent: "center", marginTop: "50px"}}>
          <Image src={portugale700} style={{width: "45px"}}></Image>

          </Row>
          
           
          </Row>

          <Row
            xs={2}
            lg={1}
            style={{
              justifyContent: "center",
              marginTop: "20px",
              textAlign: "center",
            }}
          >
            <h4
              style={{
                fontSize: "16px",
              }}
            >
              {t("header.Aviso-importante7")}
            </h4>
          </Row>
         </> : <>
         <Row style={{justifyContent: "center", marginTop: "50px"}}>
          <Image src={portugale700} style={{width: "45px"}}></Image>

          </Row>
          <Row
            xs={2}
            lg={1}
            style={{
              justifyContent: "center",
              marginTop: "20px",
              textAlign: "center",
            }}
          >
            <h4
              style={{
                fontSize: "16px",
              }}
            >
              {t("header.Aviso-importante8")}
            </h4>
          </Row>
         </> }
          

         

{/*           <Row
            xs={2}
            lg={1}
            style={{
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <h4
              style={{
                fontSize: "16px",
              }}
            >
              {t("header.pasaporte_covid_4")}
            </h4>
          </Row>

          <Row
            xs={2}
            lg={1}
            style={{
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <h4
              style={{
                fontSize: "16px",
              }}
            >
              {t("header.pasaporte_covid_5")}
            </h4>
          </Row>

          <Row
            xs={2}
            lg={1}
            style={{
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <h4
              style={{
                fontSize: "16px",
              }}
            >
              {t("header.pasaporte_covid_6")}
            </h4>
          </Row>

          <Row
            xs={2}
            lg={1}
            style={{
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <h4
              style={{
                fontSize: "16px",
              }}
            >
              {t("header.pasaporte_covid_7")}
            </h4>
          </Row>

          <Row
            xs={2}
            lg={1}
            style={{
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <h4
              style={{
                fontSize: "16px",
              }}
            >
              {t("header.pasaporte_covid_8")}
            </h4>
          </Row>

          <Row
            xs={2}
            lg={1}
            style={{
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <h4
              style={{
                fontSize: "16px",
              }}
            >
              {t("header.pasaporte_covid_9")}
            </h4>
          </Row>

          <Row
            xs={2}
            lg={1}
            style={{
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <h4
              style={{
                fontSize: "16px",
              }}
            >
              {t("header.pasaporte_covid_10")}
            </h4>
          </Row>  */}

          <Row
            style={{ marginLeft: "0", marginRight: "0", marginTop: "60px" }}
            xs={1}
            lg={2}
          >
            <Col
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",
                height: "60px",
              }}
            >
              <div className="selecion-mesCal">
                <h4 className="calendario-eventos text-wrap">
                  {i18n.language === "es" ? (
                    <Row style={{ width: "max-content" }}>
                      {ciclo.name === "Espectáculos" ? (
                        <>
                          <Col md={3}>{t("header.calendario-eventos")}</Col>
                          <Col style={{ marginLeft: "30px", padding: "0" }}>
                            {ciclo.name}
                          </Col>
                        </>
                      ) : (
                        <>
                          {ciclo.name === "Biblioteca Municipal" ? (
                            <>
                              <Col md={3}>{t("header.calendario-eventos")}</Col>
                              <Col style={{ marginLeft: "20px", padding: "0" }}>
                                {ciclo.name}
                              </Col>
                            </>
                          ) : (
                            <>
                              <Col md={3}>{t("header.calendario-eventos")}</Col>
                              <Col style={{ marginLeft: "10px", padding: "0" }}>
                                {ciclo.name}
                              </Col>
                            </>
                          )}
                        </>
                      )}
                    </Row>
                  ) : (
                    <Row style={{ width: "max-content" }}>
                      {ciclo.name === "Espectáculos" ? (
                        <>
                          <Col md={3}>{t("header.calendario-eventos")}</Col>
                          <Col style={{ marginLeft: "10px" }}>{cicloEus}</Col>
                        </>
                      ) : (
                        <>
                          <Col md={3}>{t("header.calendario-eventos")}</Col>
                          <Col>{cicloEus}</Col>
                        </>
                      )}
                    </Row>
                  )}
                </h4>
              </div>
            </Col>
            <Col
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",
              }}
            >
              <div className="mesesCal">
                <Nav
                  variant="tabs"
                  defaultActiveKey={mes}
                  onSelect={(selectedKey) => {
                    switch (selectedKey) {                  
                        case "junio":
                        setLoading(true);
                        setNav(true);
                        setMes("junio");
                        break;
                        case "julio":
                          setLoading(true);
                          setNav(true);
                          setMes("julio");
                          break;
                        case "agosto":
                        setLoading(true);
                        setNav(true);
                        setMes("agosto");
                        break;
                      default:
                        break;
                    }
                  }}
                >
                  
                  <Nav.Item>
                    <Nav.Link eventKey="junio">{t("header.junio")}</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="julio">
                      {t("header.julio")}
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item><Nav.Link eventKey="agosto">
                      {t("header.agosto")}
                    </Nav.Link></Nav.Item>
                </Nav>
              </div>
            </Col>
          </Row>

          <div
            className="row row-cols-lg-10 row-cols-1"
            style={{ marginLeft: "0", marginBottom: "150px" }}
          >
            <Tab.Content>
              <Tab.Pane eventKey="junio">
                <Row style={{ justifyContent: "center" }}>
                  <Row
                    style={{
                      justifyContent: "center",
                      marginLeft: "0px",
                      marginRight: "0px",
                    }}
                  >
                    {eventos_julio.map((data, i) => {
                      return <CartaEvento key={i} evento={data} />;
                    })}
                  </Row>
                </Row>
              </Tab.Pane>
              <Tab.Pane eventKey="julio">
                <Row style={{ justifyContent: "center" }}>
                  <Row
                    style={{
                      justifyContent: "center",
                      marginLeft: "0px",
                      marginRight: "0px",
                    }}
                  >
                    {eventos_agosto.map((data, i) => {
                      return <CartaEvento key={i} evento={data} />;
                    })}
                  </Row>
                </Row>
              </Tab.Pane>
              <Tab.Pane eventKey="agosto">
                <Row
                  style={{
                    justifyContent: "center",
                  }}
                >
                  <Row
                    style={{
                      justifyContent: "center",
                      marginLeft: "0px",
                      marginRight: "0px",
                    }}
                  >
                    {eventos_septiembre.map((data, i) => {
                      return <CartaEvento key={i} evento={data} />;
                    })}
                  </Row>
                </Row>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      )}
    </div>
  );
}

export default Calendario;
